(function () {
  'use strict';

  async function addVehicleToCart(link, status) {
    if (link.closest('[data-du-measured-section]').dataset.adding === 'true' || link.dataset.uncertain === 'true') return;
    if (!link.dataset.variantId) { status.textContent = 'This product is currently unavailable. Please contact us.'; return; }
    link.closest('[data-du-measured-section]').dataset.adding = 'true';
    const variantId = link.dataset.variantId;
    const props = {
      'Vehicle': link.dataset.vehicle,
      'Year / series': link.dataset.year,
      'Cab / body': link.dataset.cab,
      'Tub setup': link.dataset.setup,
      '_Fitment reference': link.dataset.record,
      '_Vehicle confirmation': 'Customer selected matching vehicle setup'
    };
    if (link.dataset.length) props['_Tub length (mm)'] = link.dataset.length;
    if (link.dataset.width) props['_Tub width (mm)'] = link.dataset.width;
    if (link.dataset.manualArch) props['Wheel arch width (mm) — entered by you'] = link.dataset.manualArch;
    if (link.dataset.arch) props['_Width between wheel arches (mm)'] = link.dataset.arch;

    const original = link.innerHTML;
    link.dataset.busy = 'true';
    link.setAttribute('aria-disabled', 'true');
    link.innerHTML = '<span>Adding to cart…</span><span aria-hidden="true">…</span>';
    status.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    let response;
    try {
      response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: 1, properties: props}]})
      });
    } catch (_) {
      response = null;
    }
    let body;
    try { body = response ? await response.json() : null; } catch (_) { body = null; }
    if (response && response.ok && Array.isArray(body?.items) && body.items.some(item => String(item.variant_id || item.id) === String(variantId))) {
      window.location.assign(root + 'cart');
      return;
    }

    link.dataset.busy = 'false';
    link.closest('[data-du-measured-section]').dataset.adding = 'false';
    if (!response || !body || response.status >= 500) {
      link.dataset.uncertain = 'true';
      status.textContent = 'We could not confirm the cart update. Check your cart before trying again.';
      const cartLink = document.createElement('a');
      cartLink.href = root + 'cart';
      cartLink.textContent = 'Check your cart';
      status.append(' ', cartLink);
    } else {
      link.removeAttribute('aria-disabled');
      link.innerHTML = original;
      status.textContent = typeof body.description === 'string' ? body.description : 'This item could not be added. Please contact us.';
    }
  }

  function init(section) {
    if (section.dataset.duCartInitialised === 'true') return;
    section.dataset.duCartInitialised = 'true';
    const status = section.querySelector('[data-du-measured-status]');
    const key = new URLSearchParams(location.search).get('du_product') || 'drop-in';
    const product = Array.from(section.querySelectorAll('[data-du-product]')).find(p => p.dataset.duProduct === key);
    const available = product && product.dataset.available === 'true' && product.dataset.variant;
    section.querySelector('[data-du-product-title]').textContent = product?.dataset.title || 'Selected tub product';
    section.querySelector('[data-du-arch-note]').hidden = key !== 'arch';
    const missingProduct = !product || !product.dataset.productId || !product.dataset.variant;
    if (!available) status.textContent = missingProduct ? 'We could not load the selected divider. Please call (07) 4936 1143 for help with your order.' : 'The selected divider is currently sold out. Please call (07) 4936 1143 for availability.';
    section.querySelectorAll('[data-du-measured-add]').forEach(link => {
      if (available) link.dataset.variantId = product.dataset.variant;
      else { link.setAttribute('aria-disabled', 'true'); link.parentElement.querySelector('[data-row-status]').textContent = ''; }
    });
    section.querySelectorAll('[data-du-measured-add]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        if (section.dataset.adding === 'true' || link.dataset.uncertain === 'true') return;
        if (available && key === 'arch' && !(Number(link.dataset.arch) > 0) && !link.dataset.manualArch) {
          const existing = link.parentElement.querySelector('.du-arch-form');
          if (existing) { existing.querySelector('input').focus(); return; }
          const form = document.createElement('form'); form.className = 'du-arch-form';
          const label = document.createElement('label');
          label.textContent = 'Enter the width between your wheel arches, inside any fitted liner (mm).';
          const input = document.createElement('input'); input.type = 'number'; input.min = '1'; input.step = '1'; input.required = true;
          input.id = 'arch-' + link.dataset.record; label.htmlFor = input.id;
          const submit = document.createElement('button'); submit.type = 'submit'; submit.textContent = 'Buy Now';
          const cancel = document.createElement('button'); cancel.type = 'button'; cancel.textContent = 'Cancel';
          cancel.addEventListener('click', () => { form.remove(); link.focus(); });
          form.append(label,input,submit,cancel); link.parentElement.append(form); input.focus();
          form.addEventListener('submit', e => {
            e.preventDefault(); if (!form.reportValidity()) return;
            link.dataset.manualArch = input.value; form.remove();
            addVehicleToCart(link, link.parentElement.querySelector('[data-row-status]') || status);
          });
          return;
        }
        addVehicleToCart(link, link.parentElement.querySelector('[data-row-status]') || status);
      });
    });
  }

  document.querySelectorAll('[data-du-measured-section]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.('[data-du-measured-section]').forEach(init);
  });
})();
